module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/walk-1079122c2108c3281361bd78ece4cf54.svg";